import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { PROGRESS_INDICATOR_CATEGORY_KEY, PROGRESS_INDICATOR_COMPONENT_KEY } from '../ProgressIndicator.meta.js';

import Step from './Step.js';

export default InjectedStyledComponent(Step, PROGRESS_INDICATOR_CATEGORY_KEY, PROGRESS_INDICATOR_COMPONENT_KEY, [
	'completedStep',
]);
